import React, { useState, useEffect } from "react";
import "../styles/Auth.css";
import { Link } from "react-router-dom";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    setDarkMode(localStorage.getItem("darkMode") === "true");
  }, []);

  return (
    <div className={`auth-container ${darkMode ? "dark" : ""}`}>
      <div className="auth-box">
        <h1>Welcome Back! 👋</h1>
        <p>Log in to explore amazing job opportunities.</p>

        <form>
          <input type="email" placeholder="Email Address" required />
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              required
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁"}
            </span>
          </div>
          <button type="submit">Login</button>
        </form>

        <p>
          Don't have an account? <br/> <Link to="/signup">Sign up here</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
